import React from 'react';
import PropTypes from 'prop-types';
import { EnhancedTreeSelect } from 'mkui-ext';

const noop = () => {};

class AccountingSubject extends React.Component {
  /** *******************static************************** */
  static propTypes = {
    api: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.object,
    disabled: PropTypes.bool,
    theme: PropTypes.string,
  };

  static defaultProps = {
    api: noop,
    onChange: noop,
    value: null,
    disabled: false,
  };

  /** *******************life cycle************************** */

  /** *******************handle************************** */

  /** *******************inner method************************** */
  apiAdapter = (options = {}) => {
    const { api } = this.props;
    const keyword = options.keywords;
    return new Promise(resolve => {
      if (keyword) {
        api(keyword).then(res => {
          const searchData = this.formatSearchData(res || []);
          resolve(searchData);
        });
      } else {
        api().then(res => {
          const data = this.formatData(res || []);
          resolve(data);
        });
      }
    });
  };

  formatData = data => {
    data.map(item => {
      item.inited = true;
      return item;
    });
    return data;
  };

  formatSearchData = data => {
    const searchData = [];
    const loop = list => {
      list.forEach(item => {
        if (item.children) {
          loop(item.children);
        } else {
          searchData.push({
            code: item.code,
            name: item.name,
            fullName: item.fullName,
          });
        }
      });
    };
    loop(data);
    return searchData;
  };

  searchResultRender = (item) => item.fullName

  /** *******************render************************** */
  render() {
    const { value, onChange, disabled, theme } = this.props;
    return (
      <EnhancedTreeSelect
        api={this.apiAdapter}
        lazyLoad
        value={value}
        disabled={disabled}
        labelInValue
        allowClear
        placeholder="请选择"
        searchPlaceholder="请输入名称、编码搜索..."
        onChange={onChange}
        showSearch
        rootName="会计科目"
        searchResultRender={this.searchResultRender}
        theme={theme}
      />
    );
  }
}

export default AccountingSubject;
